import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-bar-chart',
	templateUrl:'./WaBarChartProPage.html',
	styles: [],
	styleUrls:['./WaBarChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaBarChartProPage
{
	mdContent_278 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaBarChart;
\`\`\``;
	mdContent_279 = `\`\`\`java
new WaBarChart<>()
\`\`\``;
	mdContent_280 = `\`\`\`java
var chart = new WaBarChart<>();
chart.setLabel("Sales by Region");
chart.setStacked(true);
chart.setLegendPosition(LegendPosition.Top);
\`\`\``;
}
